/* eslint-disable */
import util from './md5';

function dateFormat(fmt, date) {
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'H+': date.getHours(), // 小时
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
    }
  }
  return fmt;
}
function getQueryVariable(variable)
{
       var query = window.location.hash.split("?")[1] || '';
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}

function getPlatform(){
  var platform = "web";
  if (navigator.userAgent.indexOf("youdaodict") > -1) {
    platform = "mac";
  } else if (navigator.userAgent.indexOf("windowspc") > -1) {
    platform = "pc";
  }
  return platform;
}
// 音频翻译获取签名
function getAudioSign() {
  const salt = 'youdao-video-trans'; // uuid
  const mysticTime = new Date().getTime(); // 时间戳
  const secretKey = 'Aje2zbLQbW5mSsDS';
  const str = `${mysticTime}${salt}${secretKey}`;
  const signData = util.md5(str, 'hex');
  const result = {
    signData,
    mysticTime
  };
  return result;
}
// 秒转 时:分:秒
function secondToformat(second) {
  const h = Math.floor(second / 3600);
  const HH = h <= 9 ? `0${h}` : h;
  const m = Math.floor(second / 60 % 60);
  const mm = m <= 9 ? `0${m}` : m;
  const s = Math.floor(second % 60);
  const ss = s <= 9 ? `0${s}` : s;
  const result = `${HH}:${mm}:${ss}`;
  return result;
}
function dateFormatHMS(date) {
  const difftime = date / 1000;
  let h = parseInt(difftime / 3600, 0);
  let m = parseInt((difftime % 3600) / 60, 0);
  let s = parseInt(difftime % 60, 0);
  if (s < 10) {
    s = `0${s}`;
  }
  if (m < 10) {
    m = `0${m}`;
  }
  if (h < 10) {
    h = `0${h}`;
  }
  const countDate = {
    hour: h,
    minute: m,
    second: s,
  }
  return countDate
}
// 将毫秒级时间戳转换成年.月.日格式
function formatTimeToYMD(time) {
  const date = new Date(time);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}.${month}.${day}`;
}
export default {
  dateFormat,
  getQueryVariable,
  getPlatform,
  getAudioSign,
  secondToformat,
  dateFormatHMS,
  formatTimeToYMD,
};
